import React, { useEffect, useState } from 'react';
import AnamnesisFormMobile from './anamnesisFormMobile';
import AnamnesisFormWeb from './anamnesisFormWeb';
import AnamnesisV2FormMobile from './anamnesisV2FormMobile';
import AnamnesisV2FormWeb from './anamnesisV2FormWeb';
import Loading from '../../../components/loading';
import ErrorMessage from '../../../components/errorMessage';
import { useAnamnesisIds } from './hooks/useAnamnesisIds';

const AnamnesisFormRouter = (props) => {
  const { patientId } = props;
  const isMobile = window.innerWidth < 768;

  const { anamnesisIds, isLoading, error } = useAnamnesisIds(patientId);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const useNewAnamnesis = Boolean(anamnesisIds) && !anamnesisIds.anamnesisId;

  useEffect(() => {
    if (error) {
      setShowErrorMessage(true);
    }
  }, [error]);

  if (isLoading) {
    return <Loading isToHidden={isLoading === false} />;
  }

  return (
    <>
      {showErrorMessage && (
        <ErrorMessage message={error} show={showErrorMessage} setShow={setShowErrorMessage} />
      )}
      {isMobile ? (
        useNewAnamnesis ? (
          <AnamnesisV2FormMobile {...props} />
        ) : (
          <AnamnesisFormMobile {...props} />
        )
      ) : useNewAnamnesis ? (
        <AnamnesisV2FormWeb {...props} />
      ) : (
        <AnamnesisFormWeb {...props} />
      )}
    </>
  );
};

export default AnamnesisFormRouter;
